import { useStaticQuery, graphql } from "gatsby"

export const useGetNav = () => {
  const { navigationYaml } = useStaticQuery(
    graphql`
      query GetNav {
        navigationYaml {
          navigation {
            nav_item {
              page_id
              new_tab
              label
              url
              sub_items {
                sub_item {
                  label
                  new_tab
                  page_id
                  url
                }
              }
            }
          }
        }
      }
    `
  )
  return navigationYaml
}
